import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import FontAwesomeIcon from "@/components/shared/FontAwesomeIcon.vue";

library.add(fas);

export { FontAwesomeIcon };